import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nested-form-fields"
export default class extends Controller {
  static targets = ["destroyFlag", "fields"]

  static classes = ["hidden"]

  destroy() {
    this.destroyFlagTarget.value = "true"
    this.fieldsTarget.classList.add(this.hiddenClass)
  }
}
